class CrossSellModal extends HTMLElement {
    constructor() {
      super();

        this.cross_sell_item = {};
        this.modalOverlay = document.getElementById('upsellPopupOverlay');
        this.closeBtn = document.querySelector('.cross_sell_popup__close');
        this.noThanksBtn = document.querySelector('.cross_sell_popup__no_thanks');

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.quantityEl = document.getElementById('cross-sell-quantity');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        
        this.closeBtn.addEventListener('click', () => {
            this.closeModalOpenCartDrawer();
        });

        this.noThanksBtn.addEventListener('click', () => {
            this.closeModalOpenCartDrawer();
        });

        this.modalOverlay.addEventListener('click', (e) => {
            if (e.target === this.modalOverlay) {
                this.closeModalOpenCartDrawer();
            }
        });

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.title = '';
    }

    closeModalOpenCartDrawer(){
        // Close Modal
        //this.modalOverlay.classList.remove('show');
        this.modalOverlay.classList.remove('show');
        setTimeout(() => {
            this.modalOverlay.style.display = 'none';

            // Open Cart Drawer
            if(this.cartResponse){
                this.cart.renderContents(this.cartResponse);
            }
        }, 500);
    }

    open(cartResponse, relatedItems, sourceProduct, crossSellItems) {  
        this.cartResponse = cartResponse;
        this.sourceProduct = sourceProduct;

        if (!this.sourceProduct.crossSellActive){
            this.cart.renderContents(this.cartResponse);
            return;
        }

        this.foundItem = false;

        //Get cart data with the newly added item
        this.getCart().then(cartData => {

            // Get a list of cart product ids
            let cart_product_ids = cartData.items.map( item => item.product_id);

            if (crossSellItems.length > 0 ){
                this.findItem(crossSellItems, cart_product_ids);
            } 
            if (this.foundItem){
                this.showPopup();
                return
            } else {
                this.cart.renderContents(this.cartResponse);
                return;
            }
        });
    }

    findItem(itemArray, cart_product_ids){
        for (let i = 0; i < itemArray.length; i++) {
            if (cart_product_ids.includes(itemArray[i].id) || itemArray[i].available == false) { 
                // Skip this item
                continue; 
            }
            // Found upsell item
            this.cross_sell_item = itemArray[i];
            break;
        }
        if (Object.keys(this.cross_sell_item).length === 0){
            //No available items.
            this.foundItem = false;
        } else {
            this.foundItem = true;
        }
    }

    showPopup(){
        //populate contents of modal from cross_sell_item data
        this.populatePopup();

        //Open modal now that data is populated
        this.modalOverlay.style.display = 'flex';
        setTimeout(() => {
            this.modalOverlay.classList.add('show');
        }, 40);

        // Set cookie to show only once every 2 hours
        this.setCrossSellShownCookie(1);
    }

    async getCart() {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch cart');
        return await response.json();
    }

    populatePopup(){
        // Default values
        const defaultHeading = "Go Deeper in Confident Assurance - Add Now";
        
        // Get Modal Elements
        const heading = this.querySelector('.cross-sell-heading');
        const subheading = this.querySelector('.cross-sell-subheading');
        const title = this.querySelector('.cross-sell-product-title');
        const additional_details = this.querySelector('.cross-sell-additional-details');
        const price = this.querySelector('.cross-sell-price');
        const image = this.querySelector('.cross-sell-product-image');
        const formHidden = this.querySelector('.cross-sell-product-form-hidden');

        // Populate content
        heading.innerHTML = this.cross_sell_item.heading ? this.cross_sell_item.heading : defaultHeading;
        if (this.cross_sell_item.subheading){
            subheading.innerHTML = this.cross_sell_item.subheading;
        } else {
            subheading.style.display = 'none';
        }
        if (this.cross_sell_item.additional_details){
            additional_details.innerHTML = this.cross_sell_item.additional_details;
        } else {
            additional_details.style.display = 'none';
        }
        title.innerHTML = this.cross_sell_item.variant_count > 1 ? this.cross_sell_item.first_variant.name : this.cross_sell_item.title;
        image.innerHTML = `<img src="${this.cross_sell_item.image}">`;
        formHidden.innerHTML = `<input type="hidden" name="id" data-sku="${this.cross_sell_item.first_variant.sku}" value="${this.cross_sell_item.first_variant.id}">`;
        price.innerHTML = this.cross_sell_item.price;
        this.quantityEl.value = "1";

        this.popupViewedGAEvent();
    }

    onSubmitHandler(evt) {
        evt.preventDefault();

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
        formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: 'cross-sell-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
            });
            this.handleErrorMessage(response.description);
            
            return;
            } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cross-sell-form',
                productVariantId: formData.get('id'),
                cartData: response,
            }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
            this.error = false;
            
            CartPerformance.measure("add:paint-updated-sections", () => {
                this.cartResponse = response;
                this.closeModalOpenCartDrawer();
            });
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
            this.addToCartGAEvent(formData);
        });
    }

    handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.cross-sell-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.cross-sell-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        }
    }

    // this.setCrossSellShownCookie(1) for 2 hours
    setCrossSellShownCookie(value) {
        const d = new Date();
        d.setTime(d.getTime() + (2*60*60*1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = "cross_sell_shown=" + encodeURIComponent(value) + ";" + expires + ";path=/";
    }

    popupViewedGAEvent(){
        Shopify.analytics.publish('cross_sell_popup_viewed', {
            currency: 'USD',
            items: [
                {
                    suggested_item_id: this.cross_sell_item.first_variant.sku,
                    suggested_item_name: this.cross_sell_item.title,
                    suggested_item_variant_name: this.cross_sell_item.variant_count > 1 ? this.cross_sell_item.first_variant.title : '',
                    source_item_id: this.sourceProduct.sku,
                    source_product_name: this.sourceProduct.productName,
                    source_variant_name: this.sourceProduct.variantName,
                    index: 0,
                    suggested_item_coupon: '',
                    suggested_item_discount: 0,
                    suggested_item_brand: this.cross_sell_item.vendor,
                    item_category: this.title.includes('Donation') ? 'Donations' : 'Products',
                    item_category2: this.cross_sell_item.type,
                    item_category3: '',
                    item_category4: '',
                    item_category5: '',
                    suggested_item_price: this.cross_sell_item.price,
                    source_price: this.sourceProduct.price
                }
            ]
        });
    }

    addToCartGAEvent(formData){
        Shopify.analytics.publish('cross_sell_added_to_cart', {
            currency: 'USD',
            items: [
                {
                    suggested_item_id: this.cross_sell_item.first_variant.sku,
                    suggested_item_name: this.cross_sell_item.title,
                    suggested_item_variant_name: this.cross_sell_item.variant_count > 1 ? this.cross_sell_item.first_variant.title : '',
                    source_item_id: this.sourceProduct.sku,
                    source_product_name: this.sourceProduct.productName,
                    source_variant_name: this.sourceProduct.variantName,
                    index: 0,
                    suggested_item_coupon: '',
                    suggested_item_discount: 0,
                    suggested_item_brand: this.cross_sell_item.vendor,
                    item_category: this.title.includes('Donation') ? 'Donations' : 'Products',
                    item_category2: this.cross_sell_item.type,
                    item_category3: '',
                    item_category4: '',
                    item_category5: '',
                    suggested_item_price: this.cross_sell_item.price,
                    source_price: this.sourceProduct.price,
                    quantity: formData.get('quantity')
                }
            ]
        });
    }
}

customElements.define('cross-sell-popup', CrossSellModal);
